import { SetState } from '@types'
import { createContext, useContext } from 'react'
import { Event, EventDispatcher } from 'three'

type Context = {
  controls: EventDispatcher<Event>
  setControls: SetState<EventDispatcher<Event>>
}

type Provider = { value: Context; children: JSX.Element | JSX.Element[] }

const context = {
  controls: {} as {
    zoom: (zoom: number, bool: boolean) => void
    dolly: (dolly: number) => void
    forward: (a: number, b: boolean) => void
    truck: (a: number, b: number, c: boolean) => void
  },
  setControls: (controls: EventDispatcher<Event>) => null,
}
const ViewersContext = createContext(context)

const ViewersContextProvider = ({ value, children }: Provider) => (
  //TODO this context is a mess

  <ViewersContext.Provider value={value}>{children}</ViewersContext.Provider>
)

const useViewerContext = () => useContext(ViewersContext)

export { useViewerContext, ViewersContextProvider }
